import React from "react";

function AgencyShiftsScreen() {
  return <div>AgencyShiftsScreen</div>;
}

export default AgencyShiftsScreen;
